module.exports = __webpack_public_path__ + "static/media/38_B.8ed8299a.png";